export default __webpack_public_path__ + "static/media/NotoSansKR-Thin.5d2c728f.ttf";